<template>
  <div @click="goService" class="tHServicePraseParentDiv">
    <div :style="hcf.getTextStyle({
    color:'#888'
  })">为了您的隐私安全,信息确认后将无法修改
    </div>
    <div style="display: flex;flex-direction: row;align-items: center;">
      <div :style="hcf.getTextStyle({
    color:'#888'
  })">如需修改，请联系
      </div>
      <div :style="hcf.getTextStyle({
    color:'main',fontWeight:'bold',textDecoration:'underline'
  })">人工客服
      </div>
    </div>
  </div>
</template>


<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  let useComApi = useHComApi();
  function goService(){
    useComApi.openService();
  }
</script>


<style scoped>
  .tHServicePraseParentDiv {
    margin-top: 38px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

</style>
